(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-breadcrumb"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileMedia = window.matchMedia('(max-width: 749px)');

    const getPathItems = (list) =>
      Array.from(list.children).filter(
        (item) =>
          !item.classList.contains('vq-breadcrumb-section__item--home') &&
          !item.classList.contains('vq-breadcrumb-section__item--ellipsis')
      );

    const showAll = (list, ellipsisItem, homeItem) => {
      if (homeItem) {
        homeItem.hidden = false;
        homeItem.style.display = '';
      }

      getPathItems(list).forEach((item) => {
        item.hidden = false;
        item.style.display = '';
      });

      ellipsisItem.hidden = true;
      ellipsisItem.style.display = 'none';
      list.dataset.vqBreadcrumbCollapsed = 'false';
    };

    const updateBreadcrumb = (nav) => {
      const list = nav.querySelector('.vq-breadcrumb-section__list');
      const ellipsisItem = nav.querySelector('.vq-breadcrumb-section__item--ellipsis');
      const homeItem = nav.querySelector('.vq-breadcrumb-section__item--home');
      const shouldCollapse = nav.dataset.mobileCollapse === 'true';

      if (!list || !ellipsisItem) return;

      showAll(list, ellipsisItem, homeItem);

      if (!mobileMedia.matches || !shouldCollapse) {
        nav.dataset.vqBreadcrumbExpanded = 'false';
        return;
      }

      if (nav.dataset.vqBreadcrumbExpanded === 'true') {
        return;
      }

      const pathItems = getPathItems(list);
      if (pathItems.length <= 2) return;

      pathItems.slice(0, -2).forEach((item) => {
        item.hidden = true;
        item.style.display = 'none';
      });

      ellipsisItem.hidden = false;
      ellipsisItem.style.display = 'inline-flex';

      if (homeItem) {
        homeItem.hidden = true;
        homeItem.style.display = 'none';
      }

      list.dataset.vqBreadcrumbCollapsed = 'true';
    };

    const initBreadcrumb = (nav) => {
      if (nav.dataset.vqBreadcrumbReady === 'true') return;
      nav.dataset.vqBreadcrumbReady = 'true';

      const expandButton = nav.querySelector('[data-breadcrumb-expand]');
      if (expandButton) {
        expandButton.addEventListener('click', () => {
          nav.dataset.vqBreadcrumbExpanded = 'true';
          const list = nav.querySelector('.vq-breadcrumb-section__list');
          const ellipsisItem = nav.querySelector('.vq-breadcrumb-section__item--ellipsis');
          const homeItem = nav.querySelector('.vq-breadcrumb-section__item--home');

          if (!list || !ellipsisItem) return;

          showAll(list, ellipsisItem, homeItem);
        });
      }

      updateBreadcrumb(nav);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-vq-breadcrumb]').forEach((nav) => initBreadcrumb(nav));
      root.querySelectorAll('[data-vq-breadcrumb]').forEach((nav) => updateBreadcrumb(nav));
    };

    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-vq-breadcrumb]').forEach((nav) => {
        if (!mobileMedia.matches) {
          nav.dataset.vqBreadcrumbExpanded = 'false';
        }
        updateBreadcrumb(nav);
      });
    });

    document.addEventListener('shopify:section:load', () => initAll());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const headers = document.querySelectorAll('.vq-header');
  const headerGroup = document.querySelector('#header-group');
  let headerGroupHeightRaf = null;

  const updateVqHeaderHeights = () => {
    if (headerGroup instanceof HTMLElement) {
      document.body.style.setProperty('--vq-header-group-height', `${headerGroup.offsetHeight}px`);
    }

    if (headers.length > 0) {
      const headerHeights = Array.from(headers)
        .filter((header) => header instanceof HTMLElement)
        .map((header) => header.offsetHeight);
      const maxHeaderHeight = Math.max(...headerHeights, 0);

      document.body.style.setProperty('--vq-header-height', `${maxHeaderHeight}px`);
    }
  };

  const requestVqHeaderHeightUpdate = () => {
    if (headerGroupHeightRaf) return;

    headerGroupHeightRaf = window.requestAnimationFrame(() => {
      headerGroupHeightRaf = null;
      updateVqHeaderHeights();
    });
  };

  if (headerGroup || headers.length > 0) {
    if (headerGroup) {
      headerGroup.classList.add('vq-header-group--sticky');
    }
    updateVqHeaderHeights();
    window.addEventListener('resize', requestVqHeaderHeightUpdate);
  }

  headers.forEach((header) => {
    if (header.dataset.vqInit === 'true') return;
    header.dataset.vqInit = 'true';

    const toggle = header.querySelector('[data-vq-menu-toggle]');
    const closeBtn = header.querySelector('[data-vq-menu-close]');
    const drawer = header.querySelector('.vq-header__mobile-drawer');
    const mobileViewport = header.querySelector('[data-vq-mobile-viewport]');
    const mobileTrack = header.querySelector('[data-vq-mobile-track]');
    const mobilePanels = Array.from(header.querySelectorAll('.vq-header__mobile-panel'));
    const mobileOpenButtons = header.querySelectorAll('[data-open-panel]');
    const mobileBackButtons = header.querySelectorAll('[data-back-panel]');
    const mobileLocalizationToggle = header.querySelector('[data-vq-mobile-localization-toggle]');
    const mobileLocalizationDrawer = header.querySelector('.vq-header__mobile-localization-drawer');
    const mobileFooterBottom = header.querySelector('.vq-header__mobile-footer-bottom');
    const mobileFeaturedSections = Array.from(header.querySelectorAll('[data-vq-mobile-featured]'));
    const megaOverlay = header.querySelector('[data-vq-mega-overlay]');
    const megaTriggers = header.querySelectorAll('[data-vq-mega-trigger]');
    const megaItems = header.querySelectorAll('.vq-header__nav--desktop > ul > li.has-children');
    const mobileDrawerAnimationDuration = 260;

    const updateMegaOverlayTop = () => {
      header.style.setProperty('--vq-header-overlay-top', `${header.getBoundingClientRect().bottom}px`);
    };

    const closeMegaMenus = (exceptItem = null) => {
      let hasOpenItem = false;

      megaItems.forEach((item) => {
        if (item === exceptItem && item.classList.contains('is-open')) {
          hasOpenItem = true;
          return;
        }

        if (item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          item.querySelector('[data-vq-mega-trigger]')?.setAttribute('aria-expanded', 'false');
        }
      });

      header.classList.toggle('has-open-mega', hasOpenItem);
    };

    megaTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth <= 989) return;

        const item = trigger.closest('li');
        const isOpen = item?.classList.contains('is-open');

        event.preventDefault();
        closeMegaMenus(item);

        if (!item) return;

        if (isOpen) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          header.classList.remove('has-open-mega');
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          updateMegaOverlayTop();
          header.classList.add('has-open-mega');
        }
      });
    });

    megaOverlay?.addEventListener('click', () => {
      closeMegaMenus();
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        closeMegaMenus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMegaMenus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 989) {
        closeMegaMenus();
      } else if (header.classList.contains('has-open-mega')) {
        updateMegaOverlayTop();
      }
    });

    window.addEventListener('scroll', () => {
      if (header.classList.contains('has-open-mega')) {
        updateMegaOverlayTop();
      }
    }, { passive: true });

    const resetMobilePanels = () => {
      mobilePanels.forEach((panel) => {
        panel.classList.remove(
          'is-active',
          'is-enter-from-right',
          'is-enter-from-left',
          'is-exit-to-left',
          'is-exit-to-right'
        );
      });
    };

    const closeMobileLocalization = () => {
      if (!mobileLocalizationToggle || !mobileLocalizationDrawer || !mobileFooterBottom) return;

      mobileLocalizationDrawer.hidden = true;
      mobileLocalizationToggle.setAttribute('aria-expanded', 'false');
      mobileFooterBottom.classList.remove('is-localization-open');
    };

    const openMobileLocalization = () => {
      if (!mobileLocalizationToggle || !mobileLocalizationDrawer || !mobileFooterBottom) return;

      mobileLocalizationDrawer.hidden = false;
      mobileLocalizationToggle.setAttribute('aria-expanded', 'true');
      mobileFooterBottom.classList.add('is-localization-open');
    };

    const toggleMobileLocalization = () => {
      if (!mobileLocalizationToggle || !mobileLocalizationDrawer) return;

      if (mobileLocalizationDrawer.hidden) {
        openMobileLocalization();
      } else {
        closeMobileLocalization();
      }
    };

    const initMobileFeaturedSlider = (featuredSection) => {
      if (!(featuredSection instanceof HTMLElement) || featuredSection.dataset.vqFeaturedInit === 'true') return;

      const track = featuredSection.querySelector('[data-vq-mobile-featured-track]');
      const items = Array.from(featuredSection.querySelectorAll('[data-vq-mobile-featured-item]'));
      const dots = Array.from(featuredSection.querySelectorAll('[data-vq-mobile-featured-dot]'));

      if (!(track instanceof HTMLElement) || items.length === 0) return;

      const setActiveDot = (activeIndex) => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const getActiveIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + (trackRect.width / 2);
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + (itemRect.width / 2);
          const distance = Math.abs(itemCenter - trackCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      let scrollFrame = null;
      const updateActiveState = () => {
        if (scrollFrame) return;

        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          setActiveDot(getActiveIndex());
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          items[index]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });
      });

      track.addEventListener('scroll', updateActiveState, { passive: true });
      window.addEventListener('resize', updateActiveState);
      setActiveDot(0);
      featuredSection.dataset.vqFeaturedInit = 'true';
    };

    mobileFeaturedSections.forEach(initMobileFeaturedSlider);

    const showMobilePanel = (panelId, animate = true, direction = 'forward') => {
      if (mobilePanels.length === 0) return;

      const nextPanel = mobilePanels.find((panel) => panel.dataset.panelId === panelId);
      const currentPanel = header.querySelector('.vq-header__mobile-panel.is-active');

      if (!nextPanel || currentPanel === nextPanel) return;

      if (!animate || !currentPanel) {
        resetMobilePanels();
        nextPanel.classList.add('is-active');
        return;
      }

      const enterClass = direction === 'back' ? 'is-enter-from-left' : 'is-enter-from-right';
      const exitClass = direction === 'back' ? 'is-exit-to-right' : 'is-exit-to-left';

      mobilePanels.forEach((panel) => {
        panel.classList.remove(
          'is-enter-from-right',
          'is-enter-from-left',
          'is-exit-to-left',
          'is-exit-to-right'
        );
      });

      nextPanel.classList.add(enterClass);

      requestAnimationFrame(() => {
        currentPanel.classList.remove('is-active');
        currentPanel.classList.add(exitClass);

        nextPanel.classList.add('is-active');
        nextPanel.classList.remove(enterClass);
      });

      window.setTimeout(() => {
        currentPanel.classList.remove(exitClass);
      }, 190);
    };

    if (!toggle || !drawer) return;

    const openMenu = () => {
      drawer.classList.remove('is-closing');
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('vq-menu-open');
      closeMobileLocalization();
      showMobilePanel('root', false);

      requestAnimationFrame(() => {
        drawer.classList.add('is-opening', 'is-open');
      });

      window.setTimeout(() => {
        drawer.classList.remove('is-opening');
      }, mobileDrawerAnimationDuration);
    };

    const closeMenu = () => {
      if (drawer.hidden) return;

      closeMobileLocalization();
      drawer.classList.remove('is-opening', 'is-open');
      drawer.classList.add('is-closing');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('vq-menu-open');

      window.setTimeout(() => {
        drawer.hidden = true;
        drawer.classList.remove('is-closing');
      }, mobileDrawerAnimationDuration);
    };

    toggle.addEventListener('click', () => {
      if (drawer.hidden) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    closeBtn?.addEventListener('click', closeMenu);

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        closeMenu();
        return;
      }

      if (
        mobileLocalizationDrawer &&
        mobileFooterBottom &&
        !mobileLocalizationDrawer.hidden &&
        !mobileFooterBottom.contains(event.target)
      ) {
        closeMobileLocalization();
      }
    });

    mobileOpenButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeMobileLocalization();
        showMobilePanel(button.dataset.openPanel, true, 'forward');
      });
    });

    mobileBackButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeMobileLocalization();
        showMobilePanel(button.dataset.backPanel, true, 'back');
      });
    });

    mobileLocalizationToggle?.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleMobileLocalization();
    });
  });

  // The predictive search dropdown is gated on `.predictive-search-form:focus-within`.
  // On touch devices tapping a result blurs the input before the click resolves, so the
  // panel turns `pointer-events: none` mid-tap and the navigation never happens. Mirror
  // the open state onto `.predictive-search--open`, which is only cleared by a pointerdown
  // outside the search or by Escape.
  const searchOpenClass = 'predictive-search--open';

  const closeHeaderSearches = (except = null) => {
    for (const search of document.querySelectorAll(`.vq-header__search.${searchOpenClass}`)) {
      if (search !== except) search.classList.remove(searchOpenClass);
    }
  };

  const getHeaderSearch = (event) =>
    event.target instanceof Element ? event.target.closest('.vq-header__search') : null;

  document.addEventListener('focusin', (event) => {
    const search = getHeaderSearch(event);
    closeHeaderSearches(search);
    search?.classList.add(searchOpenClass);
  });

  document.addEventListener('pointerdown', (event) => {
    closeHeaderSearches(getHeaderSearch(event));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeHeaderSearches();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sliders = document.querySelectorAll('[data-vq-home-hero-slider]');

  sliders.forEach((slider) => {
    if (slider.dataset.vqInit === 'true') return;
    slider.dataset.vqInit = 'true';

    const track = slider.querySelector('[data-vq-home-hero-track]');
    const slides = slider.querySelectorAll('.vq-hero-slider__slide');
    const next = slider.querySelector('[data-vq-home-hero-next]');
    const prev = slider.querySelector('[data-vq-home-hero-prev]');
    const dotsWrap = slider.querySelector('[data-vq-home-hero-dots]');

    if (!track || slides.length === 0) return;

    if (slides.length < 2) {
      track.style.transform = 'translateX(0)';
      return;
    }

    let current = 0;
    let timer = null;
    const autoplaySpeed = parseInt(slider.dataset.autoplay || '4000', 10);

    const renderDots = () => {
      if (slides.length < 2) return;
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vq-hero-slider__dot';
        dot.setAttribute('aria-label', `Gehe zu Slide ${index + 1}`);
        if (index === current) dot.classList.add('is-active');
        dot.addEventListener('click', () => goTo(index, true));
        dotsWrap.appendChild(dot);
      });
    };

    const syncDots = () => {
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.vq-hero-slider__dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
      });
    };

    const goTo = (index, resetTimer) => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      syncDots();
      if (resetTimer) startAuto();
    };

    const startAuto = () => {
      if (timer) window.clearInterval(timer);
      if (!Number.isFinite(autoplaySpeed) || autoplaySpeed <= 0 || slides.length < 2) return;
      timer = window.setInterval(() => {
        goTo(current + 1, false);
      }, autoplaySpeed);
    };

    next?.addEventListener('click', () => goTo(current + 1, true));
    prev?.addEventListener('click', () => goTo(current - 1, true));

    slider.addEventListener('mouseenter', () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    });

    slider.addEventListener('mouseleave', startAuto);

    renderDots();
    goTo(0, false);
    startAuto();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = `vq-main-collection-return-target:${window.location.pathname}${window.location.search}`;
    let hasRestored = false;
    let filterSubmitTimeout = null;

    const restoreCardPosition = () => {
      if (hasRestored) return;

      const storedValue = sessionStorage.getItem(storageKey);
      if (!storedValue) return;

      let cardId = '';
      let scrollY = null;

      try {
        const parsed = JSON.parse(storedValue) || {};
        cardId = parsed.cardId || '';
        scrollY = Number.isFinite(parsed.scrollY) ? parsed.scrollY : null;
      } catch (_error) {
        sessionStorage.removeItem(storageKey);
        return;
      }

      if (!cardId && scrollY === null) {
        sessionStorage.removeItem(storageKey);
        return;
      }

      hasRestored = true;
      sessionStorage.removeItem(storageKey);

      requestAnimationFrame(() => {
        if (scrollY !== null && Math.abs(window.scrollY - scrollY) > 24) {
          window.scrollTo({ top: scrollY, behavior: 'instant' });
          return;
        }

        const card = cardId ? document.getElementById(cardId) : null;
        if (card instanceof HTMLElement) {
          const rect = card.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

          if (!isVisible) {
            card.scrollIntoView({ behavior: 'instant', block: 'nearest' });
          }
        }
      });
    };

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target instanceof Element ? event.target.closest('.vq-product-card__link') : null;
        if (!(link instanceof HTMLAnchorElement)) return;

        const card = link.closest('.vq-main-collection__grid-item');
        const cardId = card?.getAttribute('id');
        if (!cardId) return;

        sessionStorage.setItem(
          storageKey,
          JSON.stringify({
            cardId,
            scrollY: window.scrollY,
          })
        );
      },
      { capture: true }
    );

    const submitFiltersForm = (form) => {
      if (!(form instanceof HTMLFormElement)) return;

      if (filterSubmitTimeout) {
        window.clearTimeout(filterSubmitTimeout);
        filterSubmitTimeout = null;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.submit();
    };

    const buildCollectionFilterUrl = (form) => {
      const url = new URL(form.action || window.location.pathname, window.location.origin);
      const params = new URLSearchParams(new FormData(form));

      if (params.get('filter.v.price.gte') === '') params.delete('filter.v.price.gte');
      if (params.get('filter.v.price.lte') === '') params.delete('filter.v.price.lte');

      params.delete('page');
      url.search = params.toString();

      return url.toString();
    };

    window.VQCollectionDebouncedSubmit = (form) => {
      if (!(form instanceof HTMLFormElement)) return;

      if (filterSubmitTimeout) {
        window.clearTimeout(filterSubmitTimeout);
      }

      filterSubmitTimeout = window.setTimeout(() => {
        filterSubmitTimeout = null;
        submitFiltersForm(form);
      }, 450);
    };

    window.VQCollectionApplyMobileFilters = (button) => {
      if (!(button instanceof HTMLElement)) return;

      const form = button.closest('form');
      if (!(form instanceof HTMLFormElement)) return;

      const targetUrl = buildCollectionFilterUrl(form);
      const dialogComponent = button.closest('dialog-component');

      if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
        dialogComponent.closeDialog().then(() => {
          window.location.assign(targetUrl);
        });
        return;
      }

      window.location.assign(targetUrl);
    };

    window.VQCollectionToggleSortCheckbox = (input) => {
      if (!(input instanceof HTMLInputElement)) return;

      const container = input.closest('.vq-filter-values--sort');
      if (!(container instanceof HTMLElement)) return;

      const inputs = container.querySelectorAll('input[type="checkbox"][name="sort_by"]');
      inputs.forEach((item) => {
        if (item instanceof HTMLInputElement && item !== input) {
          item.checked = false;
        }
      });

      if (!input.checked) {
        input.checked = true;
      }
    };

    const initStickyFilters = () => {
      const filters = Array.from(document.querySelectorAll('.vq-collection-layout > .vq-filters'));
      const header = document.querySelector('.vq-header');
      const stickyMedia = window.matchMedia('(min-width: 990px)');

      if (!filters.length) return;

      const updateStickyOffset = () => {
        filters.forEach((filter) => {
          if (!(filter instanceof HTMLElement)) return;

          if (!stickyMedia.matches) {
            filter.style.removeProperty('--vq-collection-filters-sticky-top');
            return;
          }

          const headerBottom = header instanceof HTMLElement ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;

          filter.style.setProperty('--vq-collection-filters-sticky-top', `${headerBottom}px`);
        });
      };

      let stickyOffsetRaf = null;
      const requestStickyOffsetUpdate = () => {
        if (stickyOffsetRaf) return;

        stickyOffsetRaf = window.requestAnimationFrame(() => {
          stickyOffsetRaf = null;
          updateStickyOffset();
        });
      };

      updateStickyOffset();
      window.addEventListener('scroll', requestStickyOffsetUpdate, { passive: true });
      window.addEventListener('resize', requestStickyOffsetUpdate);

      if (stickyMedia.addEventListener) {
        stickyMedia.addEventListener('change', requestStickyOffsetUpdate);
      } else if (stickyMedia.addListener) {
        stickyMedia.addListener(requestStickyOffsetUpdate);
      }

      if (header instanceof HTMLElement && 'ResizeObserver' in window) {
        new ResizeObserver(requestStickyOffsetUpdate).observe(header);
      }
    };

    document.addEventListener('DOMContentLoaded', restoreCardPosition, { once: true });
    window.addEventListener('pageshow', restoreCardPosition);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyFilters, { once: true });
    } else {
      initStickyFilters();
    }
    document.addEventListener('click', (event) => {
      const openSortDropdown = document.querySelector('.vq-sort-dropdown[open]');
      if (!(openSortDropdown instanceof HTMLDetailsElement)) return;

      if (event.target instanceof Node && openSortDropdown.contains(event.target)) return;

      openSortDropdown.removeAttribute('open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
